import React from 'react'

import { styled, LinearProgress, Typography } from '@mui/material'

interface Props {
    text: string
    value?: number | null
}

const ProgressBarContainer = styled('div')`
    margin: 8px 0;
    width: 100%;
`

export const LinearProgressBar: React.FC<Props> = ({ text, value }: Props) => {
    const progress = Math.min(Math.max(value || 0, 0), 100)

    return (
        <>
            <ProgressBarContainer>
                <LinearProgress variant="determinate" value={progress} />
            </ProgressBarContainer>
            <Typography color="primary" variant="body2">
                {progress ? progress.toFixed(1) : '0.0'}%
            </Typography>
            <Typography variant="caption">{text}</Typography>
        </>
    )
}
